<!--
    描述：概算价基本信息组件
    时间：2020.5.20
    created by zjj
-->
<template>
	<div class="baseForm-layout">
		<div class="baseForm-header"
			 v-if="showLeft">基础信息:<el-button title="折叠"
					   class="ml10"
					   type="text"
					   @click="changeShow"
					   icon="el-icon-d-arrow-left"></el-button>
			<div class="btnGroups">
				<el-button size="mini"
						   @click="isDisabled = !isDisabled">{{ isDisabled ? '解锁' : '锁定' }}</el-button>
				<el-button size="mini"
						   type="primary"
						   @click="saveData">保存</el-button>
			</div>
		</div>
		<div class="baseForm-header"
			 v-else>
			<el-button title="展开"
					   size=""
					   type="text"
					   @click="changeShow"
					   icon="el-icon-d-arrow-right"></el-button>
		</div>
		<div class="baseForm-content textdisable"
			 v-show="showLeft">
			<el-form label-width="150px"
					 v-for="(item, index) in formInfoList.list"
					 :key="'item'+index">

				<!-- 文本型 -->
				<template v-if="item.formType === '1005001' && item.additional.suffix == '元'">
					<el-form-item :label="item.title">
						<el-input v-model="item.value"
								  :disabled="isDisabled">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
				</template>

				<!-- 文本型 -->
				<el-form-item v-if="item.formType === '1005002'"
							  :label="item.title">
					<el-input v-model="item.value"
							  :disabled="isDisabled">
					</el-input>
				</el-form-item>

				<!-- 日期型 -->
				<el-form-item v-if="item.formType === '1005003' && item.additional.dateType == 'date'"
							  :label="item.title">
					<el-date-picker class="setWidth"
									v-model="item.value"
									:disabled="isDisabled"></el-date-picker>
				</el-form-item>

				<!-- 文本 -->
				<el-form-item v-if="item.formType === '1005005'"
							  :label="item.title">
					<el-input v-model="item.value"
							  type="textarea"
							  :disabled="isDisabled"></el-input>
				</el-form-item>

				<!-- 码表型 -->
				<el-form-item v-if="item.formType === '1005007' && item.additional.dictionaryTypeName == '概算编制定额依据'"
							  :label="item.title">
					<el-select class="setWidth"
							   v-model="item.value"
							   :disabled="isDisabled"
							   placeholder="请选择">
						<el-option v-for="(item, index) in quotaList"
								   :key="'item' + index"
								   :label="item.sname"
								   :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="item.formType === '1005007' && item.additional.dictionaryTypeName == '控制价信息价、信息价依据'"
							  :label="item.title">
					<el-select class="setWidth"
							   v-model="item.value"
							   :disabled="isDisabled"
							   placeholder="请选择">
						<el-option v-for="(item, index) in infoMoneyList"
								   :key="'item' + index"
								   :label="item.sname"
								   :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import { costEcho, budgetPriceSave } from '@/api/modules/project_costfiles'
import { mapState } from 'vuex'
export default {
	name: 'baseprice', // 概算价基本信息组件
	props: {
		projectId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			formInfoList: {
				list: []
			},
			isDisabled: true,
			showLeft: true
		}
	},
	computed: {
		// 获取码表值
		...mapState('dict', {
			quotaList: state => state.gsbzdeyj, //概算编制定额依据
			infoMoneyList: state => state.xxjyj //信息价依据
		}),
	},
	methods: {
		//排序
		sortId(a, b) {
       		return a.sort - b.sort;
		},
		
		getInfo() {
			//获取基本信息数据
			setTimeout(() => {
				let params = {}
				params.id = this.projectId
				costEcho(params).then(res => {
					if (res.code === 0) {
						res.data
							? (this.formInfoList.list = res.data)
							: (this.formInfoList.list = [])
						this.formInfoList.list.forEach((item, index) => {
							item.isRequired == 1
								? item.isRequired == true
								: item.isRequired == false
						})

						if (this.formInfoList.list != null){
							this.formInfoList.list = this.formInfoList.list.sort(this.sortId)
						}
						
					} else {
						this.$message.console.error('请求失败！')
					}
				})
			}, 100)
		},
		// 控制左侧展开收起
		changeShow() {
			this.showLeft = !this.showLeft
			this.$emit('changeShow', this.showLeft)
		},

		//保存
		saveData() {
			let params = JSON.parse(JSON.stringify(this.formInfoList.list))
			budgetPriceSave(params).then(res => {
				if (res.code === 0) {
					this.isDisabled = true
					this.$message.success('保存成功！')
				} else {
					this.$message.error('请求失败！')
				}
			})
		}
	},
	created() {
		this.getInfo()
	},
	mounted(){
		
	}
}
</script>
<style lang="less" scoped>
</style>
